/* eslint-disable jsx-a11y/alt-text */
import { FC, useCallback, useContext, useState } from "react";
import CustomTextInput from "../../../../shared/CustomInput/CustomTextInput";
import { IDirector } from "../../../../models/director";
import Typhography from "../../../../shared/Typhography/Typhography";
import PhoneInput from "react-phone-input-2";
import { useDropzone } from "react-dropzone";
import { UploadSimpleIcon } from "@phosphor-icons/react";
import CustomButton from "../../../../shared/CustomButton/CustomButton";
import style from "./DirectorForm.module.scss";
import { useEndpoints } from "../../../../hooks/useEndpoints";
import { useAppSelector } from "../../../../store";
import { useSimpleForm } from "../../../../hooks/useSimpleForm";
import { AuthContext } from "../../../../providers/authProvider";
import toast from "react-hot-toast";
const MAX_SIZE = 24 * 1024 * 1024; // 24 MB in byte

export const DirectorForm: FC<{
  form: IDirector;
  handleChange: any;
  onClose: any;
}> = ({ onClose }) => {
  const selectedEntity = useAppSelector((st) => st.me.selectedEntity);
  const { userImage } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const { form, handleChange } = useSimpleForm({
    name: (selectedEntity as any).name,
    email: (selectedEntity as any).email,
    firstName: selectedEntity?.firstName || "",
    lastName: selectedEntity?.lastName || "",
    phone: (selectedEntity as any)?.phone,
    image: userImage
      ? { file: null, url: userImage }
      : (null as { file: File | null; url: string } | null),
  });
  const { patchDirector } = useEndpoints();
  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles.length) {
      if (form.image) URL.revokeObjectURL((form as any)?.image?.url);

      const file = acceptedFiles[0];
      const url = URL.createObjectURL(file);
      handleChange("image", { file, url });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    accept: {
      "image/*": [],
    },
    maxFiles: 1,
    maxSize: MAX_SIZE,
  });

  const onSave = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("name", form.name);
      formData.append("email", form.email);
      formData.append("firstName", form.firstName);
      formData.append("lastName", form.lastName);
      formData.append("phone", form.phone);
      form.image?.file && formData.append("image", form.image.file);
      !form.image && formData.append("deleteImage", "true");

      await patchDirector(selectedEntity!._id, formData);
      onClose();
      toast.success(`Utenza aggiornata`);
      window.location.reload();
    } catch (error) {
      toast.error(`Errore inaspettato`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex flex-column gap-2">
        <Typhography size="bold-14">Logo</Typhography>
        <div className="d-flex gap-2">
          <input {...getInputProps()} />
          {!form.image?.url ? (
            <div className={style.dropZoneContainer} {...getRootProps()}>
              <UploadSimpleIcon className={style.uploadIcon} />
            </div>
          ) : (
            <div className={style.dropZoneContainer2}>
              <img src={(form as any).image.url} className={style.logoImage} />
            </div>
          )}
          <div className="d-flex flex-column gap-1">
            <CustomButton onClick={open} color="outline">
              Carica immagine
            </CustomButton>
            {!form.image?.url ? (
              <Typhography size="regular-12">
                ( Formato .png, .jpg e .jpeg 24mb max )
              </Typhography>
            ) : (
              <CustomButton
                typeText="danger"
                color="outline"
                onClick={() => {
                  handleChange("image", null);
                }}
              >
                Rimuovi
              </CustomButton>
            )}
          </div>
        </div>
      </div>
      <div className="col-12 col-sm-6">
        <CustomTextInput
          label="Nome"
          value={form?.firstName}
          onChange={({ target }) => {
            handleChange("firstName", target.value);
          }}
        />
      </div>
      <div className="col-12 col-sm-6">
        <CustomTextInput
          label="Cognome"
          value={form?.lastName}
          onChange={({ target }) => {
            handleChange("lastName", target.value);
          }}
        />
      </div>
      <div className="col-12">
        <CustomTextInput
          label="Nome centro sportivo"
          value={form?.name}
          onChange={({ target }) => {
            handleChange("name", target.value);
          }}
        />
      </div>
      <div className="col-12">
        <CustomTextInput label="Email" value={form?.email} disabled />
      </div>
      <div className="col-12">
        <Typhography size="bold-14" className="label-input">
          Numero di telefono
        </Typhography>
        <PhoneInput
          placeholder="Inserisci numero di telefono"
          inputClass="w-100"
          country={"it"}
          value={form.phone}
          onChange={(phone) => {
            handleChange("phone", phone);
          }}
        />
      </div>

      <div className="d-flex justify-content-end gap-2">
        <CustomButton color="outline" onClick={onClose}>
          Annulla
        </CustomButton>
        <CustomButton color="secondary" onClick={onSave} isLoading={isLoading}>
          Conferma
        </CustomButton>
      </div>
    </>
  );
};
